"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var PlusCircle2_exports = {};
__export(PlusCircle2_exports, {
  default: () => PlusCircle2_default
});
module.exports = __toCommonJS(PlusCircle2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.1836 9.56641H13.2344C13.4167 9.56641 13.5729 9.63802 13.7031 9.78125C13.8464 9.91146 13.918 10.0677 13.918 10.25C13.918 10.4323 13.8464 10.5951 13.7031 10.7383C13.5729 10.8685 13.4167 10.9336 13.2344 10.9336H11.1836V12.9844C11.1836 13.1667 11.112 13.3294 10.9688 13.4727C10.8385 13.6029 10.6823 13.668 10.5 13.668C10.3177 13.668 10.1549 13.6029 10.0117 13.4727C9.88151 13.3294 9.81641 13.1667 9.81641 12.9844V10.9336H7.76562C7.58333 10.9336 7.42057 10.8685 7.27734 10.7383C7.14714 10.5951 7.08203 10.4323 7.08203 10.25C7.08203 10.0677 7.14714 9.91146 7.27734 9.78125C7.42057 9.63802 7.58333 9.56641 7.76562 9.56641H9.81641V7.51562C9.81641 7.33333 9.88151 7.17708 10.0117 7.04688C10.1549 6.90365 10.3177 6.83203 10.5 6.83203C10.6823 6.83203 10.8385 6.90365 10.9688 7.04688C11.112 7.17708 11.1836 7.33333 11.1836 7.51562V9.56641ZM10.5 17.75C9.45833 17.75 8.48828 17.5547 7.58984 17.1641C6.67839 16.7734 5.8776 16.2396 5.1875 15.5625C4.51042 14.8724 3.97656 14.0716 3.58594 13.1602C3.19531 12.2617 3 11.2917 3 10.25C3 9.20833 3.19531 8.23828 3.58594 7.33984C3.97656 6.42839 4.51042 5.63411 5.1875 4.95703C5.8776 4.26693 6.67839 3.72656 7.58984 3.33594C8.48828 2.94531 9.45833 2.75 10.5 2.75C11.5417 2.75 12.5117 2.94531 13.4102 3.33594C14.3216 3.72656 15.1159 4.26693 15.793 4.95703C16.4831 5.63411 17.0234 6.42839 17.4141 7.33984C17.8047 8.23828 18 9.20833 18 10.25C18 11.2917 17.8047 12.2617 17.4141 13.1602C17.0234 14.0716 16.4831 14.8724 15.793 15.5625C15.1159 16.2396 14.3216 16.7734 13.4102 17.1641C12.5117 17.5547 11.5417 17.75 10.5 17.75ZM10.5 16.3828C11.3464 16.3828 12.1406 16.2201 12.8828 15.8945C13.638 15.582 14.2891 15.1523 14.8359 14.6055C15.3958 14.0456 15.832 13.388 16.1445 12.6328C16.4701 11.8906 16.6328 11.0964 16.6328 10.25C16.6328 9.40365 16.4701 8.60938 16.1445 7.86719C15.832 7.11198 15.3958 6.46094 14.8359 5.91406C14.2891 5.35417 13.638 4.91797 12.8828 4.60547C12.1406 4.27995 11.3464 4.11719 10.5 4.11719C9.65365 4.11719 8.85938 4.27995 8.11719 4.60547C7.36198 4.91797 6.70443 5.35417 6.14453 5.91406C5.59766 6.46094 5.16797 7.11198 4.85547 7.86719C4.52995 8.60938 4.36719 9.40365 4.36719 10.25C4.36719 11.0964 4.52995 11.8906 4.85547 12.6328C5.16797 13.388 5.59766 14.0456 6.14453 14.6055C6.70443 15.1523 7.36198 15.582 8.11719 15.8945C8.85938 16.2201 9.65365 16.3828 10.5 16.3828Z",
      fill: "currentColor"
    }
  )
);
const SvgPlusCircle2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var PlusCircle2_default = SvgPlusCircle2;
